import React, { ForwardedRef, forwardRef, useRef } from "react";
import Button, { TButtonProps } from "../Button/Button";
import { TPrimitiveId } from "../Select/Select";
import Menu, { TMenuProps } from "./Menu";
import { useOverlay } from "../Overlay/OverlayProvider";
import { UpdateEvent } from "../GUIEvents";
import { TAnchorProps } from "../Overlay/AnchoredBackdrop";

export type TMenuButtonProps<ID extends TPrimitiveId> = Omit<TButtonProps,"onChange"> & {
    defaultValue?:ID
    menuProps:TMenuProps<ID>
    anchorProps?:TAnchorProps
    onUpdate?:(e:UpdateEvent<ID,HTMLDivElement>) => void
}

export interface IMenuButton<ID extends TPrimitiveId> {

}

var g_id = 0
function MenuButton<ID extends TPrimitiveId>(props:TMenuButtonProps<ID>, ref?:ForwardedRef<IMenuButton<ID>>) {
    const {menuProps:_menuProps,children,onClick,onUpdate,anchorProps,...buttonProps} = props
    const {onUpdate:_mpChange,...menuProps} = _menuProps
    const {addOverlay,popOverlay,hasOverlay} = useOverlay()
    const followId = useRef<string>(`mb_${g_id}`)
    const menuId = useRef<string>(`menu_${g_id++}`)

    const _onUpdate = (e:UpdateEvent<ID,HTMLDivElement>) => {
        _mpChange?.(e)        // change event to menu listener
        onUpdate?.(e)         // change event to button listener
        popOverlay(menuId.current)
    }
    const _onClick = (e:React.MouseEvent<HTMLButtonElement>) => {
        !hasOverlay(menuId.current) && addOverlay(menuId.current, {
            children: <Menu {...menuProps} onUpdate={_onUpdate} defaultValue={props.defaultValue}/>, 
            anchor: {...props.anchorProps,follow:followId.current}
        })
        props.onClick?.(e)
    }
    return <Button {...buttonProps} onClick={_onClick} follow-id={followId.current}>{children}</Button>
}

export default forwardRef(MenuButton) as <ID extends TPrimitiveId>(props:TMenuButtonProps<ID>&{ref?:ForwardedRef<IMenuButton<ID>>}) => JSX.Element